import React from 'react';
import { oneOf } from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import { SpinnerWrapper } from './Spinner.styles';
export const Spinner = _ref => {
  let {
    color,
    size
  } = _ref;
  return /*#__PURE__*/React.createElement(SpinnerWrapper, {
    color: color,
    size: size
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    size: size
  }));
};
Spinner.propTypes = {
  color: oneOf(['blue', 'green', 'purple', 'grey']),
  size: oneOf(['large', 'medium', 'small'])
};
Spinner.defaultProps = {
  color: 'grey',
  size: 'medium'
};